var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blob",style:(_vm.cssProps)},[_c('router-link',{attrs:{"to":_vm.link}},[_c('span',{staticClass:"clickarea"},[_vm._v(_vm._s(_vm.label))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }